import React from 'react'

function FAQs({ faqsConst }) {
   return (
      <section className="faq-section section_theme_2_bg">
         <div className="container">
            <h2 className="section_heading_title faq-title">
               Frequently Asked Questions (FAQs)
            </h2>
            <p className="faq-subtitle">
               Got questions? Here are some common ones we've answered. If you
               need more details, feel free to reach out or book a consultation
               session.
            </p>

            <div className="accordion faq-accordion" id="faqAccordion">
               {faqsConst.map((faq, idx) => (
                  <div className="accordion-item" key={idx}>
                     <p className="accordion-header">
                        <button
                           className="accordion-button collapsed"
                           type="button"
                           data-bs-toggle="collapse"
                           data-bs-target={`#faq${idx + 1}`}
                        >
                           {faq.question}
                        </button>
                     </p>
                     <div
                        id={`faq${idx + 1}`}
                        className="accordion-collapse collapse"
                        data-bs-parent="#faqAccordion"
                     >
                        <div className="accordion-body">{faq.answer}</div>
                     </div>
                  </div>
               ))}
            </div>
         </div>
      </section>
   )
}

export default FAQs
